import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EditIcon from '@mui/icons-material/Edit';


import { Box, IconButton, Theme, Typography, useTheme } from '@mui/material';

const BUTTON_TYPES = {
  create: {
    text: 'Create',
    icon: <AddIcon />,
  },
  upload: {
    text: 'Upload',
    icon: <FileUploadIcon />,
  },
  uploadVendor: {
    text: 'Batch Create',
    icon: <FileUploadIcon />,
  },
  export: {
    text: 'Export',
    icon: <FileDownloadIcon />,
  },
  downloadTemplate: {
    text: 'Download Template',
    icon: <FileDownloadIcon />,
  },
  add: {
    text: 'Add Vendor Account',
    icon: <AddIcon />,
  },
  vendorDocumentUpload: {
    text: 'Upload Document',
    icon: <FileUploadIcon />,
  },
  editFeeConfiguration: {
    text: 'Edit Fee Configuration',
    icon: <EditIcon />,
  },
  addFirm: {
    text: 'Add Firm',
    icon: <AddIcon />,
  },
  editAutoSweep: {
    text: 'Edit',
    icon: <EditIcon />
  },
  addRow: {
    text: 'Add Row',
    icon: <AddIcon />,
  },
};

const useStyles = makeStyles()((theme: Theme) => ({
  buttonBox: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '14px 32px',
    borderRadius: '12px',
    color: theme.palette.common.white,
    cursor: 'pointer',
  },
  buttonIcon: {
    padding: 0,
    color: theme.palette.common.white,
    svg: {
      width: '20px',
      height: '20px',
    },
  },
  linkMargin: {
    textDecoration: 'none',
    // marginRight: '20px',

    '@media (max-width: 550px)': {
      marginRight: 0,
    },
  },
}));

interface ViewCommonButtonProps {
  path?: string;
  type: keyof typeof BUTTON_TYPES;
  onClick?: () => void;
}

const ViewCommonButton = ({ path, type, onClick }: ViewCommonButtonProps) => {
  const theme = useTheme();
  const styles = useStyles();

  const buttonContent = (
    <Box
      className={styles.classes.buttonBox}
      bgcolor={type === 'create' || type === 'editFeeConfiguration' || type === 'editAutoSweep' || type === 'addRow' ? theme.palette.info.main : theme.palette.info.dark}
      onClick={onClick}
      role="button"
      aria-label={BUTTON_TYPES[type].text}
      tabIndex={0}
      onKeyDown={(event) => {
        if ((event.key === 'Enter' || event.key === ' ') && onClick) {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <IconButton className={styles.classes.buttonIcon}>{BUTTON_TYPES[type].icon}</IconButton>
      <Typography fontSize="16px" lineHeight="19px" fontWeight="500">
        {BUTTON_TYPES[type].text}
      </Typography>
    </Box>
  );

  if (!path) {
    return buttonContent;
  }

  return (
    <Link to={path} onClick={onClick} className={styles.classes.linkMargin}>
      {buttonContent}
    </Link>
  );
};

export default ViewCommonButton;